import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
  htmlTooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.9)',
    maxWidth: 400,
    fontSize: '1rem',
    border: '1px solid #dadde9',
    '& b': {
      fontWeight: '400'
    }
  }
});

const CustomTooltip = ({ classes, children, content }) => (
  <Tooltip
    classes={{ tooltip: classes.htmlTooltip }}
    title={<Fragment>{content}</Fragment>}
  >
    {children}
  </Tooltip>
);

CustomTooltip.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.objectOf(PropTypes.string),
  content: PropTypes.node
};

export default withStyles(styles)(CustomTooltip);
